/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_2_DescInputs */

const en_mk_feature_2_desc = /** @type {(inputs: Mk_Feature_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set project rules. Repeated failures create a fix task with the evidence of what went wrong.`)
};

const id_mk_feature_2_desc = /** @type {(inputs: Mk_Feature_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapkan aturan proyek. Kegagalan berulang menghasilkan tugas perbaikan dengan bukti masalahnya.`)
};

/**
* | output |
* | --- |
* | "Set project rules. Repeated failures create a fix task with the evidence of what went wrong." |
*
* @param {Mk_Feature_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_2_desc = /** @type {((inputs?: Mk_Feature_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_2_desc(inputs)
	return en_mk_feature_2_desc(inputs)
});